import React from 'react';

import axios from 'axios';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';

import App from './components/global-components/App';
import Settings from './static/models/Settings';

function renderApp(settings: Settings) {
    if (settings.googleTagManagerId) {
        TagManager.initialize({
            gtmId: settings.googleTagManagerId,
        });
    }

    ReactDOM.render(
        <React.StrictMode>
            <App settings={settings} />
        </React.StrictMode>,
        document.getElementById('root'),
    );
}

async function loadSettings() {
    const response = await axios.get<Settings>('./settings.json');
    return response.data;
}

loadSettings().then(settings => renderApp(settings));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
